<div class="search-bar-container">
  <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
    <mat-icon matPrefix class="material-symbols-rounded">search</mat-icon>
    <input
      matInput
      placeholder="Search here"
      [formControl]="searchControl"
      (keydown.enter)="onSearch()"
      [matAutocomplete]="auto"
    />
  </mat-form-field>

  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onOptionSelected($event.option.value)"
    [displayWith]="displayResultTitle"
    class="search-autocomplete"
  >
    @if (typeaheadResults$ | async; as typeahead) {
      @for (result of typeahead.results; track result.id) {
        <mat-option [value]="result" class="typeahead-option">
          <span class="typeahead-badge">{{ result.entityType }}</span>
          @if (result.metadata?.['issue_key']; as issueKey) {
            <span class="typeahead-key">{{ issueKey }}</span>
          }
          <span class="typeahead-snippet">{{ result.snippet || result.title }}</span>
        </mat-option>
      }
    }
    @if (searchControl.value.trim().length >= 2) {
      <mat-option
        class="view-all-option"
        [value]="buildViewAllOption(searchControl.value)"
      >
        <mat-icon class="material-symbols-rounded view-all-icon">arrow_forward</mat-icon>
        <span class="view-all-label">
          View all results for "{{ searchControl.value.trim() }}"
        </span>
      </mat-option>
    }
  </mat-autocomplete>
</div>
